<template>
  <div>
    <!-- <filed v-for="(item,key) in arr" :key="key" @titleTxt="title(value,key)"></filed> -->

    <div class="container">
      <Space v-if="getControl() == 1">
        &nbsp;&nbsp;企业代码：
        <Input v-model="ClientCode" @click="SelectClientSwitch = !SelectClientSwitch" placeholder="企业代码"
          style="width: 100px" />
        <br />
        <br />
      </Space>
      <Space>
        &nbsp;&nbsp;溯源标题：
        <Input v-model="title1" placeholder="标题" style="width: 200px" />
      </Space>
      <br />
      <br />

      <Space>
        &nbsp;&nbsp;图片内容：
        <Input v-model="imgObj.title" placeholder="图片字段标题" style="width: 200px" />
      </Space>
      <br />
      <br />
      <FiledUpload :imgArr="imgObj.imgarr" @addImg="addImgArr"></FiledUpload>

      <br />
      <Space>
        &nbsp;&nbsp;文本字段：（流水号=“@serial@”） </Space>
      <!-- 文本字段 -->
      <div v-for="(item, key) in arr" :key="key">
        <filed v-if="item.type == 'text'" @titleTxt="title($event, key)" @message="message($event, key)"
          :titles="propsTitleVal(key)" :messages="propsMessageVal(key)" @delect="jian(key)"></filed>
      </div>

      <br />
      &nbsp;&nbsp;
      <Button type="info" @click="add()">新增字段</Button>&nbsp;

      <br /><br />
      <Space>
        &nbsp;&nbsp;备注说明：
        <Input v-model="remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" placeholder="请输入说明..."></Input>
      </Space>
    </div>
    <div class="btn">
      <Button @click="echo()" type="success" style="width: 100px; height: 40px">保&nbsp;存</Button>
    </div>

    <!-- 选择企业 -->
    <transition name="fade">
      <SelectClient v-if="SelectClientSwitch" @Value="SelectClientVal" @close="SelectClientClose"></SelectClient>
    </transition>
  </div>
</template>

<script>
import filed from "@/views/filedList/newFiled/filed";
import FiledUpload from "@/views/FiledUpload";
import { NewFiledList, DelFiledList } from "@/api/index";
import SelectClient from "@/views/selectClient";
import { mapState } from "vuex";
export default {
  data() {
    return {
      number: 10,
      title1: "",
      ClientCode: "1001",
      imgObj: {
        title: "",
        type: "img",
        imgarr: [],
      },
      arr: [
        {
          title: "",
          type: "text",
          message: "",
        },
      ],
      remark: "",
      SelectClientSwitch: false,
    };
  },
  components: {
    filed,
    SelectClient,
    FiledUpload,
  },
  watch: {},
  computed: mapState({
    control: (state) => state.control,
  }),
  created() {
    //   console.log('1-'+this.control);
  },
  methods: {
    getControl() {
      return this.control;
    },
    // 添加图片
    addImgArr(value) {
      this.imgObj.imgarr.push(value);
    },
    SelectClientClose() {
      this.SelectClientSwitch = false;
    },
    SelectClientVal(value) {
      this.ClientCode = value;
      this.SelectClientSwitch = false;
    },
    propsTitleVal(key) {
      return this.arr[key].title;
    },
    propsMessageVal(key) {
      return this.arr[key].message;
    },
    add() {
      this.arr.push({ title: "", type: "text", message: "" });
    },
    // 完成按钮
    echo() {
      var ab = this.arr;
      let type = "文本";
      if (this.imgObj.imgarr.length !== 0) {
        ab.unshift(this.imgObj);
        type = "文本,图片";
      }
      let datas = ab;
      NewFiledList({
        clientcode: this.ClientCode,
        dataType: type,
        datas: JSON.stringify(datas),
        titless: this.title1,
        remark: this.remark,
      }).then((res) => {
        // console.log(res);
        if (res == 1) {
          this.$emit("close", true);
        }
      });
    },
    title(event, key) {
      this.arr[key].title = event;
    },
    message(event, key) {
      this.arr[key].message = event;
    },
    jian(key) {
      // console.log(key);
      this.arr[key] = {};
      this.arr.splice(key, 1);
    },
  },
};
</script>

<style scoped>
.container {
  max-height: calc(100% - 100px);
  overflow-y: auto;
}
</style>
